"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _prefix = _interopRequireDefault(require("../../prefix"));

var BasicTextInput = function BasicTextInput(_ref) {
  var autoComplete = _ref.autoComplete,
      autoFocus = _ref.autoFocus,
      disabled = _ref.disabled,
      htmlId = _ref.htmlId,
      onKeyDown = _ref.onKeyDown,
      maxLength = _ref.maxLength,
      name = _ref.name,
      placeholder = _ref.placeholder,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onTextInputChange = _ref.onTextInputChange,
      readOnly = _ref.readOnly,
      required = _ref.required,
      rows = _ref.rows,
      type = _ref.type,
      value = _ref.value,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["autoComplete", "autoFocus", "disabled", "htmlId", "onKeyDown", "maxLength", "name", "placeholder", "onBlur", "onFocus", "onTextInputChange", "readOnly", "required", "rows", "type", "value"]); // We disable the maxLength by setting it to null if the value provided exceeds the maxLength.
  // This assures that the initial value passed is populated in the TextInput instead of being truncated.
  // We display an error message when an initial value is passed that exceeds the maxLength.

  var getMaxLength = function getMaxLength() {
    if (value) {
      return maxLength && value.length <= maxLength ? maxLength : null;
    } else {
      return null;
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_FormControl["default"], Object.assign({
    bsClass: "".concat(_prefix["default"], "form-control"),
    className: htmlId + "-textInput",
    componentClass: type === "textarea" ? type : "input",
    id: htmlId,
    onBlur: onBlur,
    onChange: onTextInputChange,
    onFocus: onFocus,
    rows: type === "textarea" ? rows : null,
    type: type || "text"
  }, (0, _objectSpread2["default"])({
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    disabled: disabled
  }, maxLength && {
    maxLength: getMaxLength()
  }, {
    name: name,
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    value: value
  }, props)));
};

var _default = BasicTextInput;
exports["default"] = _default;